// generated by the plop

import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { cloneDeep } from 'lodash';
import { PROGRESS_STATUSES } from 'symbols';
import { InvoiceService } from '../../services/invoice.service';
import { InvoiceModel, INVOICES_LOCAL_STORAGE_KEY } from '../../symbols';
import { CreatedInvoiceByWS, UpdatedInvoiceByWS } from '../invoice-list/invoice-list.actions';
import {
  CreateAcceptanceCertificate,
  CreateAcceptanceCertificateTemplate,
  CreateInvoice,
  CreateInvoiceFail,
  CreateInvoiceSuccess,
  CreateInvoiceTemplate,
  CreatePurchaseAgreement,
  CreatePurchaseAgreementTemplate,
  CreateServiceAgreement,
  CreateServiceCertificateTemplate,
  CreateWaybill,
  CreateWaybillTemplate,
  DeleteAcceptanceCertificateTemplate,
  DeleteInvoiceTemplate,
  DeleteLocalInvoice,
  DeletePurchaseAgreementTemplate,
  DeleteServiceCertificateTemplate,
  DeleteWaybillTemplate,
  GetAcceptanceCertificateTemplateList,
  GetInvoiceById,
  GetInvoiceByIdFail,
  GetInvoiceByIdSuccess,
  GetInvoiceTemplateList,
  GetPurchaseAgreementTemplateList,
  GetServiceCertificateTemplateList,
  GetWaybillTemplateList,
  SetCurrentInvoiceId,
  UpdateAcceptanceCertificateTemplate,
  UpdateAcceptanceCertificateTemplateFail,
  UpdateInvoice,
  UpdateInvoiceFail,
  UpdateInvoiceSuccess,
  UpdateInvoiceTemplate,
  UpdateInvoiceTemplateFail,
  UpdateInvoiceTemplateSuccess,
  UpdateLocalInvoice,
  UpdatePurchaseAgreementTemplate,
  UpdatePurchaseAgreementTemplateFail,
  UpdateServiceCertificateTemplate,
  UpdateServiceCertificateTemplateFail,
  UpdateWaybillTemplate,
  UpdateWaybillTemplateFail
} from './invoice-manage.actions';
import { INVOICE_MANAGE_STATE_DEFAULT, InvoiceManageStateModel } from './invoice-manage.model';

@State({ name: 'InvoiceManage', defaults: INVOICE_MANAGE_STATE_DEFAULT })
@Injectable()
export class InvoiceManageState implements NgxsOnInit {

  constructor(private invoicesService: InvoiceService) {
  }

  @Selector()
  static realVersionInvoices(state: InvoiceManageStateModel): { [id: string]: InvoiceModel } {
    return state.realVersionInvoices;
  }

  @Selector()
  static currentInvoice(state: InvoiceManageStateModel): InvoiceModel {
    return state.invoices?.[state.currentInvoiceId];
  }

  @Selector()
  static loadInvoiceStatus(state: InvoiceManageStateModel): PROGRESS_STATUSES {
    return state.loadInvoiceStatus;
  }


  @Selector()
  static allTemplateList(state: InvoiceManageStateModel): InvoiceManageStateModel['invoiceTemplateList'] {
    return [...state.invoiceTemplateList, ...state.waybillTemplateList, ...state.purchaseAgreementTemplateList, ...state.serviceCertificateTemplateList, ...state.acceptanceCertificateTemplateList];
  }

  @Selector()
  static invoiceTemplateList(state: InvoiceManageStateModel): InvoiceManageStateModel['invoiceTemplateList'] {
    return state.invoiceTemplateList;
  }

  @Selector()
  static waybillTemplateList(state: InvoiceManageStateModel): InvoiceManageStateModel['invoiceTemplateList'] {
    return state.waybillTemplateList;
  }


  @Selector()
  static purchaseAgreementTemplateList(state: InvoiceManageStateModel): InvoiceManageStateModel['purchaseAgreementTemplateList'] {
    return state.purchaseAgreementTemplateList;
  }


  @Selector()
  static serviceCertificateTemplateList(state: InvoiceManageStateModel): InvoiceManageStateModel['serviceCertificateTemplateList'] {
    return state.serviceCertificateTemplateList;
  }


  @Selector()
  static acceptanceCertificateTemplateList(state: InvoiceManageStateModel): InvoiceManageStateModel['acceptanceCertificateTemplateList'] {
    return state.acceptanceCertificateTemplateList;
  }


  ngxsOnInit(ctx: StateContext<InvoiceManageStateModel>) {
    const localStorageInvoices = localStorage.getItem(INVOICES_LOCAL_STORAGE_KEY);
    if (localStorageInvoices) {
      const invoices = JSON.parse(localStorageInvoices);
      ctx.patchState({
        invoices
      });
    }
    ctx.dispatch([
      new GetInvoiceTemplateList(),
      new GetAcceptanceCertificateTemplateList(),
      new GetServiceCertificateTemplateList(),
      new GetWaybillTemplateList(),
      new GetPurchaseAgreementTemplateList()
    ]);
  }

  @Action(GetInvoiceTemplateList)
  getInvoiceTemplateList(ctx: StateContext<InvoiceManageStateModel>): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.getInvoiceTemplateList().subscribe({
      next: templateList => ctx.patchState({
        invoiceTemplateList: templateList,
        loadTemplateListStatus: PROGRESS_STATUSES.SUCCESS
      }),
      error: err => ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL })
    });
  }

  @Action(GetServiceCertificateTemplateList)
  getServiceAgreementTemplateList(ctx: StateContext<InvoiceManageStateModel>): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.getServiceAgreementTemplateList().subscribe({
      next: templateList => ctx.patchState({
        serviceCertificateTemplateList: templateList,
        loadTemplateListStatus: PROGRESS_STATUSES.SUCCESS
      }),
      error: err => ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL })
    });
  }

  @Action(GetAcceptanceCertificateTemplateList)
  getAcceptanceCertificateTemplateList(ctx: StateContext<InvoiceManageStateModel>): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.getAcceptanceCertificateTemplateList().subscribe({
      next: templateList => ctx.patchState({
        acceptanceCertificateTemplateList: templateList,
        loadTemplateListStatus: PROGRESS_STATUSES.SUCCESS
      }),
      error: err => ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL })
    });
  }

  @Action(GetWaybillTemplateList)
  getWaybillTemplateList(ctx: StateContext<InvoiceManageStateModel>): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.getWaybillTemplateList().subscribe({
      next: templateList => ctx.patchState({
        waybillTemplateList: templateList,
        loadTemplateListStatus: PROGRESS_STATUSES.SUCCESS
      }),
      error: err => ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL })
    });
  }

  @Action(GetPurchaseAgreementTemplateList)
  getPurchaseAgreementTemplateList(ctx: StateContext<InvoiceManageStateModel>): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.getPurchaseAgreementTemplateList().subscribe({
      next: templateList => ctx.patchState({
        purchaseAgreementTemplateList: templateList,
        loadTemplateListStatus: PROGRESS_STATUSES.SUCCESS
      }),
      error: err => ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL })
    });
  }

  @Action(CreateWaybillTemplate)
  createWaybillTemplate(ctx: StateContext<InvoiceManageStateModel>, { template, name }: CreateWaybillTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.createWaybillTemplate(name, template).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateWaybillTemplateFail(err));
      }
    });
  }

  @Action(CreateInvoiceTemplate)
  createInvoiceTemplate(ctx: StateContext<InvoiceManageStateModel>, { template, name }: CreateInvoiceTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.createInvoiceTemplate(name, template).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateInvoiceTemplateFail(err));
      }
    });
  }

  @Action(CreateServiceCertificateTemplate)
  createServiceAgreementTemplate(ctx: StateContext<InvoiceManageStateModel>, {
    template,
    name
  }: CreateServiceCertificateTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.createServiceAgreementTemplate(name, template).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateServiceCertificateTemplateFail(err));
      }
    });
  }


  @Action(CreateAcceptanceCertificateTemplate)
  createAcceptanceCertificateTemplate(ctx: StateContext<InvoiceManageStateModel>, {
    template,
    name
  }: CreateAcceptanceCertificateTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.createAcceptanceCertificateTemplate(name, template).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateAcceptanceCertificateTemplateFail(err));
      }
    });
  }


  @Action(CreatePurchaseAgreementTemplate)
  createPurchaseAgreementTemplate(ctx: StateContext<InvoiceManageStateModel>, {
    template,
    name
  }: CreatePurchaseAgreementTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.createPurchaseAgreementTemplate(name, template).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdatePurchaseAgreementTemplateFail(err));
      }
    });
  }


  @Action(UpdateInvoiceTemplate)
  updateInvoiceTemplate(ctx: StateContext<InvoiceManageStateModel>, { template, id }: UpdateInvoiceTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.updateInvoiceTemplate(id, {
      html: template.html,
      project: template.project,
      formatId: template.formatId,
      css: template.css
    }, template.name).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateInvoiceTemplateFail(err));
      }
    });
  }

  @Action(UpdatePurchaseAgreementTemplate)
  updatePurchaseAgreementTemplate(ctx: StateContext<InvoiceManageStateModel>, {
    template,
    id
  }: UpdatePurchaseAgreementTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.updatePurchaseAgreementTemplate(id, {
      html: template.html,
      project: template.project,
      formatId: template.formatId,
      css: template.css
    }, template.name).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdatePurchaseAgreementTemplateFail(err));
      }
    });
  }


  @Action(UpdateWaybillTemplate)
  updateWaybillTemplate(ctx: StateContext<InvoiceManageStateModel>, { template, id }: UpdateWaybillTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.updateWaybillTemplate(id, {
      html: template.html,
      project: template.project,
      formatId: template.formatId,
      css: template.css
    }, template.name).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateWaybillTemplateFail(err));
      }
    });
  }


  @Action(UpdateAcceptanceCertificateTemplate)
  updateAcceptanceCertificateTemplate(ctx: StateContext<InvoiceManageStateModel>, {
    template,
    id
  }: UpdateAcceptanceCertificateTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.updateAcceptanceCertificateTemplate(id, {
      html: template.html,
      project: template.project,
      formatId: template.formatId,
      css: template.css
    }, template.name).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateAcceptanceCertificateTemplateFail(err));
      }
    });
  }


  @Action(UpdateServiceCertificateTemplate)
  updateServiceAgreementTemplate(ctx: StateContext<InvoiceManageStateModel>, {
    template,
    id
  }: UpdateServiceCertificateTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.updateServiceAgreementTemplate(id, {
      html: template.html,
      project: template.project,
      formatId: template.formatId,
      css: template.css
    }, template.name).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateServiceCertificateTemplateFail(err));
      }
    });
  }


  @Action(DeleteInvoiceTemplate)
  deleteInvoiceTemplate(ctx: StateContext<InvoiceManageStateModel>, { id }: DeleteInvoiceTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.deleteInvoiceTemplate(id).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateInvoiceTemplateFail(err));
      }
    });
  }


  @Action(DeleteServiceCertificateTemplate)
  deleteServiceAgreementTemplate(ctx: StateContext<InvoiceManageStateModel>, { id }: DeleteServiceCertificateTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.deleteServiceAgreementTemplate(id).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateServiceCertificateTemplateFail(err));
      }
    });
  }


  @Action(DeleteAcceptanceCertificateTemplate)
  deleteAcceptanceCertificateTemplate(ctx: StateContext<InvoiceManageStateModel>, { id }: DeleteAcceptanceCertificateTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.deleteAcceptanceCertificateTemplate(id).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),
          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateAcceptanceCertificateTemplateFail(err));
      }
    });
  }


  @Action(DeleteWaybillTemplate)
  deleteWaybillTemplate(ctx: StateContext<InvoiceManageStateModel>, { id }: DeleteWaybillTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.deleteWaybillTemplate(id).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdateWaybillTemplateFail(err));
      }
    });
  }


  @Action(DeletePurchaseAgreementTemplate)
  deletePurchaseAgreementTemplate(ctx: StateContext<InvoiceManageStateModel>, { id }: DeletePurchaseAgreementTemplate): void {
    ctx.patchState({
      loadTemplateListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    this.invoicesService.deletePurchaseAgreementTemplate(id).subscribe({
      next: () => ctx.dispatch(
        [
          new GetInvoiceTemplateList(),
          new UpdateInvoiceTemplateSuccess(),

          new GetWaybillTemplateList(),
          new GetAcceptanceCertificateTemplateList(),
          new GetServiceCertificateTemplateList(),
          new GetPurchaseAgreementTemplateList()
        ]),
      error: err => {
        ctx.patchState({ loadTemplateListStatus: PROGRESS_STATUSES.FAIL });
        ctx.dispatch(new UpdatePurchaseAgreementTemplateFail(err));
      }
    });
  }


  @Action(GetInvoiceById)
  getInvoiceById(ctx: StateContext<InvoiceManageStateModel>, { id }: GetInvoiceById): void {
    ctx.patchState({
      loadInvoiceStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    if (ctx.getState().invoices?.[id]) {
      this.invoicesService.getInvoiceById(id).subscribe({
        next: invoice => {
          if (invoice) {
            ctx.dispatch(new UpdatedInvoiceByWS(invoice));
          } else {
            ctx.patchState({
              loadInvoiceStatus: PROGRESS_STATUSES.SUCCESS
            });
          }
          ctx.patchState({
            currentInvoiceId: id
          });
        },
        error: err => ctx.dispatch(new GetInvoiceByIdFail(err))
      });
    } else {
      this.invoicesService.getInvoiceById(id).subscribe({
        next: invoice => ctx.dispatch(new GetInvoiceByIdSuccess(invoice)),
        error: err => ctx.dispatch(new GetInvoiceByIdFail(err))
      });
    }
  }

  @Action(GetInvoiceByIdSuccess)
  getInvoiceByIdSuccess(ctx: StateContext<InvoiceManageStateModel>, { invoice }: GetInvoiceByIdSuccess): void {
    const invoices = cloneDeep(ctx.getState().invoices);
    invoices[invoice.id] = invoice;
    ctx.patchState({
      invoices,
      currentInvoiceId: invoice.id,
      loadInvoiceStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action(GetInvoiceByIdFail)
  getInvoiceByIdFail(ctx: StateContext<InvoiceManageStateModel>, { error }: GetInvoiceByIdFail): void {
    ctx.patchState({
      loadInvoiceStatus: PROGRESS_STATUSES.FAIL
    });
  }

  @Action(SetCurrentInvoiceId)
  setCurrentInvoiceId(ctx: StateContext<InvoiceManageStateModel>, { id }: SetCurrentInvoiceId): void {
    ctx.patchState({
      currentInvoiceId: id
    });
  }

  @Action(UpdateLocalInvoice)
  updateLocalInvoice(ctx: StateContext<InvoiceManageStateModel>, { invoice }: UpdateLocalInvoice): void {
    const invoices = cloneDeep(ctx.getState().invoices);
    invoices[invoice.id] = { ...invoices[invoice.id], ...invoice };
    localStorage.setItem(INVOICES_LOCAL_STORAGE_KEY, JSON.stringify(invoices));
    ctx.patchState({
      invoices
    });
  }

  @Action(DeleteLocalInvoice)
  deleteLocalInvoice(ctx: StateContext<InvoiceManageStateModel>, { id }: DeleteLocalInvoice): void {
    const invoices = cloneDeep(ctx.getState().invoices);
    const realVersionInvoices = cloneDeep(ctx.getState().realVersionInvoices);

    delete invoices[id];
    delete realVersionInvoices[id];
    ctx.patchState({
      invoices,
      realVersionInvoices
    });
  }


  @Action(UpdateInvoice)
  updateInvoice(ctx: StateContext<InvoiceManageStateModel>, { id, invoice, force }: UpdateInvoice): void {
    ctx.patchState({
      updateInvoiceStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.invoicesService.updateInvoice(id, invoice, force).subscribe({
      next: updatedInvoice => ctx.dispatch(new UpdateInvoiceSuccess(updatedInvoice)),
      error: err => ctx.dispatch(new UpdateInvoiceFail(err))
    });
  }

  @Action(UpdateInvoiceSuccess)
  updateInvoiceSuccess(ctx: StateContext<InvoiceManageStateModel>, { invoice }: UpdateInvoiceSuccess): void {
    const invoices = cloneDeep(ctx.getState().invoices);
    ctx.patchState({
      updateInvoiceStatus: PROGRESS_STATUSES.SUCCESS,
      invoices: { ...invoices, [invoice.id]: { ...invoices[invoice.id], version: invoice.version } }
    });
  }

  @Action([UpdatedInvoiceByWS])
  updateInvoiceByWS(ctx: StateContext<InvoiceManageStateModel>, { invoice }: UpdatedInvoiceByWS): void {
    const realVersionInvoices = cloneDeep(ctx.getState().realVersionInvoices);
    const invoices = cloneDeep(ctx.getState().invoices);
    const invoiceExist = invoices[invoice.id];
    if (invoiceExist) {
      ctx.patchState({
        loadInvoiceStatus: PROGRESS_STATUSES.SUCCESS,
        invoices: {
          ...invoices,
          [invoice.id]: {
            ...invoices[invoice.id],
            updater: invoice.updater
          }
        }
      });
    }


    ctx.patchState({
      loadInvoiceStatus: PROGRESS_STATUSES.SUCCESS,
      realVersionInvoices: { ...realVersionInvoices, [invoice.id]: invoice }
    });
  }

  @Action(CreatedInvoiceByWS)
  createdInvoiceByWS(ctx: StateContext<InvoiceManageStateModel>, { invoice }: CreatedInvoiceByWS): void {
    const invoices = cloneDeep(ctx.getState().invoices);
    ctx.patchState({
      invoices: {
        ...invoices,
        [invoice.id]: {
          ...invoices[invoice.id],
          isChanged: false,
          isNew: false,
          updater: invoice.updater
        }
      }
    });
  }


  @Action(CreateInvoice)
  createInvoice(ctx: StateContext<InvoiceManageStateModel>, { invoice }: CreateInvoice): void {
    ctx.patchState({
      updateInvoiceStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.invoicesService.createInvoice(invoice).subscribe({
      next: createdInvoice => ctx.dispatch(new CreateInvoiceSuccess(createdInvoice)),
      error: err => ctx.dispatch(new CreateInvoiceFail(err))
    });
  }

  @Action(CreateWaybill)
  createWaybill(ctx: StateContext<InvoiceManageStateModel>, { invoiceId }: CreateWaybill): void {
    ctx.patchState({
      updateInvoiceStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    const invoices = cloneDeep(ctx.getState().invoices);

    this.invoicesService.createWaybill(invoiceId).subscribe({
      next: invoice => ctx.patchState({
        invoices: {
          ...invoices,
          [invoice.id]: {
            ...invoices[invoice.id],
            isChanged: false,
            isNew: false,
            waybill: invoice.waybill,
            waybillId: invoice.waybillId,
            updater: invoice.updater
          }
        }
      })
    });
  }

  @Action(CreateAcceptanceCertificate)
  createAcceptanceCertificate(ctx: StateContext<InvoiceManageStateModel>, { invoiceId }: CreateAcceptanceCertificate): void {
    ctx.patchState({
      updateInvoiceStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    const invoices = cloneDeep(ctx.getState().invoices);

    this.invoicesService.createAcceptanceCertificate(invoiceId).subscribe({
      next: invoice => ctx.patchState({
        invoices: {
          ...invoices,
          [invoice.id]: {
            ...invoices[invoice.id],
            isChanged: false,
            isNew: false,
            acceptanceCertificate: invoice.acceptanceCertificate,
            acceptanceCertificateId: invoice.acceptanceCertificateId,
            updater: invoice.updater
          }
        }
      })
    });
  }

  @Action(CreateServiceAgreement)
  createServiceAgreement(ctx: StateContext<InvoiceManageStateModel>, { invoiceId }: CreateServiceAgreement): void {
    ctx.patchState({
      updateInvoiceStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    const invoices = cloneDeep(ctx.getState().invoices);

    this.invoicesService.createServiceAgreement(invoiceId).subscribe({
      next: invoice => ctx.patchState({
        invoices: {
          ...invoices,
          [invoice.id]: {
            ...invoices[invoice.id],
            isChanged: false,
            isNew: false,
            serviceAgreement: invoice.serviceAgreement,
            serviceAgreementId: invoice.serviceAgreementId,
            updater: invoice.updater
          }
        }
      })
    });
  }

  @Action(CreatePurchaseAgreement)
  createPurchaseAgreement(ctx: StateContext<InvoiceManageStateModel>, { invoiceId }: CreatePurchaseAgreement): void {
    ctx.patchState({
      updateInvoiceStatus: PROGRESS_STATUSES.IN_PROGRESS
    });
    const invoices = cloneDeep(ctx.getState().invoices);

    this.invoicesService.createPurchaseAgreement(invoiceId).subscribe({
      next: invoice => ctx.patchState({
        invoices: {
          ...invoices,
          [invoice.id]: {
            ...invoices[invoice.id],
            isChanged: false,
            isNew: false,
            purchaseAgreement: invoice.purchaseAgreement,
            purchaseAgreementId: invoice.purchaseAgreementId,
            updater: invoice.updater
          }
        }
      })
    });
  }


  @Action(CreateInvoiceSuccess)
  createInvoiceSuccess(ctx: StateContext<InvoiceManageStateModel>, { invoice }: CreateInvoiceSuccess): void {
    ctx.patchState({
      updateInvoiceStatus: PROGRESS_STATUSES.SUCCESS
    });
  }

  @Action(CreateInvoiceFail)
  createInvoiceFail(ctx: StateContext<InvoiceManageStateModel>, { error }: CreateInvoiceFail): void {
    ctx.patchState({
      updateInvoiceStatus: PROGRESS_STATUSES.FAIL
    });
  }

}


